// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-80f6786e] .modal-body{padding-bottom:0;padding-top:0}", ""]);
// Exports
module.exports = exports;
